var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepliedTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.867 1.13301C12.9915 1.25749 13.0328 1.44272 12.973 1.6083L9.03773 12.5059C9.03346 12.5177 9.02869 12.5294 9.02345 12.5408C8.89523 12.8206 8.61571 13 8.30795 13C8.0033 13 7.72631 12.8242 7.59638 12.5492L5.54786 8.45214L1.45071 6.40358C1.17577 6.27365 1 5.99667 1 5.69202C1 5.38426 1.17938 5.10473 1.45916 4.97652C1.47061 4.97128 1.48227 4.96651 1.49411 4.96224L12.3917 1.02701C12.5573 0.967211 12.7425 1.00852 12.867 1.13301ZM6.43879 8.20336L8.28935 11.9045L11.4273 3.21481L6.43879 8.20336ZM10.7852 2.57266L2.09543 5.71062L5.79664 7.56121L10.7852 2.57266Z",
    fill: "#051123",
    stroke: "#051123",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepliedTag);
export default __webpack_public_path__ + "static/media/replied_tag.1edd3ba5109174464f321c0bc3ecf635.svg";
export { ForwardRef as ReactComponent };